<vy-box [hasMarginBottom]="true" [noPadding]="true">
  <ng-container box-content>
    <vy-accordion [type]="accordionType">
      <vy-accordion-item
        #paxServices
        [borderTop]="true"
        [name]="'booking_details_component.booking_services_component.title' | translate"
        [isDisabled]="!passengerServices || !passengerServices[0] || !passengerServices[0].outboundServices"
      >
        <ng-container accordionHeader>
          <vy-icon-text
            [type]="iconType"
            [size]="iconSize"
            [label]="'booking_details_component.booking_services_component.title' | translate"
            [iconClass]="'ds-icon-check-in-counter'"
          >
          </vy-icon-text>
        </ng-container>
        <app-booking-services [bookingServices]="passengerServices ?? []"> </app-booking-services>
      </vy-accordion-item>

      @if(sharedBookingServices && sharedBookingServices.length !== 0){
      <vy-accordion-item #otherServices [name]="'booking_details_component.other_services_component.title' | translate">
        <ng-container accordionHeader>
          <vy-icon-text
            [type]="iconType"
            [size]="iconSize"
            [label]="'booking_details_component.other_services_component.title' | translate"
            [iconClass]="'ds-icon-check-in-counter'"
          >
          </vy-icon-text>
        </ng-container>
        <app-shared-booking-services [sharedBookingServices]="sharedBookingServices"></app-shared-booking-services>
      </vy-accordion-item>
      } @if(!contactInformationAgency){
      <vy-accordion-item #agencyContact>
        <ng-container accordionHeader>
          <vy-icon-text
            [type]="iconType"
            [size]="iconSize"
            [label]="'booking_details_component.contact_information_component.agency_title' | translate"
            [iconClass]="'ds-icon-contact'"
          >
          </vy-icon-text>
        </ng-container>
        <app-contact-information [contactInformation]="contactInformationPrimary"></app-contact-information>
      </vy-accordion-item>
      }@else { @if(!!contactInformationPrimary){
      <vy-accordion-item #paxContact>
        <ng-container accordionHeader>
          <vy-icon-text
            [type]="iconType"
            [size]="iconSize"
            [label]="'booking_details_component.contact_information_component.pax_title' | translate"
            [iconClass]="'ds-icon-contact'"
          >
          </vy-icon-text>
        </ng-container>
        <app-contact-information [contactInformation]="contactInformationPrimary"></app-contact-information>
      </vy-accordion-item>
      }
      <vy-accordion-item #agencyContact>
        <ng-container accordionHeader>
          <vy-icon-text
            [type]="iconType"
            [size]="iconSize"
            [label]="'booking_details_component.contact_information_component.agency_title' | translate"
            [iconClass]="'ds-icon-contact'"
          >
          </vy-icon-text>
        </ng-container>
        <app-contact-information [contactInformation]="contactInformationAgency"></app-contact-information>
      </vy-accordion-item>
      }

      <vy-accordion-item
        #payment
        [active]="!!paymentDetails.journeys"
        [isDisabled]="!paymentDetails.journeys"
        class="paymentsAccordion"
      >
        <ng-container accordionHeader>
          <div class="payments-accordion-header">
            <vy-icon-text
              [type]="iconType"
              [size]="iconSize"
              [label]="'booking_details_component.payment_details_component.title' | translate"
              [iconClass]="'ds-icon-credit-card-back'"
            >
            </vy-icon-text>
            <span
              ><strong
                >{{ 'ds.basket.totals.total' | translate }}: {{paymentDetails.bookingTotalAmount}}
                {{currencyCode}}</strong
              ></span
            >
          </div>
        </ng-container>
        <app-payment-detail
          [paymentDetails]="paymentDetails"
          [currencyCode]="currencyCode"
          [itineraryType]="itineraryType"
          [flightJourneys]="flightJourneys"
          [stations]="stations"
          [recordLocator]="recordLocator"
        ></app-payment-detail>
      </vy-accordion-item>
    </vy-accordion>
  </ng-container>
</vy-box>
